import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LoftReport } from './Pages';

export const LoftReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LoftReport} />
    </Fragment>
)